'use client';
import { useEffect, useState } from 'react';
import { loadEveningConfig, currentEveningVariant, currentGreeting, type EveningVariant } from '@/lib/eveningClient';

/** React hook: { active, variant, greeting } — re-evaluated every minute (the window can open while the page is open). */
export function useEvening(): { active: boolean; variant: EveningVariant | null; greeting: string | null } {
  const [, setTick] = useState(0);
  useEffect(() => {
    let live = true;
    loadEveningConfig().then(() => { if (live) setTick(n => n + 1); });
    const t = setInterval(() => setTick(n => n + 1), 60_000);
    return () => { live = false; clearInterval(t); };
  }, []);
  const variant = currentEveningVariant();
  return { active: !!variant, variant, greeting: currentGreeting() };
}

